






































/**
 * @copyright       Palace Resorts
 * @description     Componente Card
 * @author          CCHAN
 * @creationDate    20/09/2021
 */
import GlobalMixin from "@/mixins/global";
import CardBase from "@/components/CardBase/CardBase.vue";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma.
  components: {
    // Incluimos el layout que utilizará este módulo
    CardBase,
  },
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: true,
    },
    subIcon: {
      type: String,
      default: undefined,
    },
    subIconColor: {
      type: String,
      default: undefined,
    },
    subTextColor: {
      type: String,
      default: undefined,
    },
    subText: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: undefined,
    },
    smallValue: {
      type: String,
      default: undefined,
    },
    progressValue: {
      type: String,
      default: undefined,
    },
  },
});
